export const comparisonData = [
  {
    feature: "Speed",
    oopbuy: "Fast – instant link pasting",
    traditional: "Slow – manual browsing required",
  },
  {
    feature: "Organization",
    oopbuy: "High – structured spreadsheet layout",
    traditional: "Low – scattered across tabs",
  },
  {
    feature: "Error Rate",
    oopbuy: "Low – automated data entry",
    traditional: "High – manual copy-paste errors",
  },
  {
    feature: "Price Tracking",
    oopbuy: "Built-in comparison columns",
    traditional: "Requires external tools",
  },
  {
    feature: "Multi-Item Orders",
    oopbuy: "Batch processing supported",
    traditional: "One item at a time",
  },
];